import api from "./api";

/**
 * The four roles every business starts with. They cannot be deleted and the
 * owner's permissions are fixed; everything else about them is editable, and a
 * business may add as many roles of its own as it likes.
 */
export const SYSTEM_ROLES = ["owner", "manager", "receptionist", "staff"];

/** GET /business/roles — the whole set; a business has a handful. */
export const fetchRoles = async () => {
  const { data } = await api.get("/business/roles");
  return data.data.roles;
};

/**
 * GET /business/permissions — the platform catalogue, already grouped by module
 * ({ branches: ["branches.view", ...], ... }), and the implication rule that
 * goes with it ({ "branches.create": ["branches.view"], ... }): what one
 * permission grants on its own, because a role that may create records must be
 * able to see them.
 *
 * The server enforces that rule whatever the portal draws. The map is read
 * here so the editor ticks exactly what the server will honour rather than
 * keeping a second copy of the rule that can drift from it.
 */
export const fetchPermissionCatalogue = async () => {
  const { data } = await api.get("/business/permissions");

  return { permissions: data.data.permissions, implies: data.data.implies ?? {} };
};

export const createRole = async ({ name, permissions }) => {
  const { data } = await api.post("/business/roles", { name, permissions });
  return data.data.role;
};

/** PUT /business/roles/{id} — the permissions sent replace the role's whole set. */
export const updateRole = async (id, { name, permissions }) => {
  const { data } = await api.put(`/business/roles/${id}`, { name, permissions });
  return data.data.role;
};

export const deleteRole = (id) => api.delete(`/business/roles/${id}`);
